export default {
    namespaced: true,
    state: {
        profiles: null,
        profile: null,
        tmpProfile: null,
        manualProfileCompletion: false
    },
    mutations: {
        setProfiles: (state, profiles) => {
            if(profiles.length) {
                state.profiles = profiles;
            }
            else {
                state.profiles = null;
            }
        },

        setProfile: (state, profile) => {
            state.profile = profile;
        },

        setTmpProfile: (state, tmpProfile) => {
            state.tmpProfile = tmpProfile;
        },

        setManualProfileCompletion: (state, status) => {
            state.manualProfileCompletion = status;
        },

        resetProfiles(state) {
            state.profiles = null;
            state.profile = null;
        },
        resetTmpProfile(state) {
            state.tmpProfile = null;
        }
    },
    actions: {

        getProfiles(context) {
            return this.$axios.get('/profiles')
                .then(response => {
                    context.commit('setProfiles', response.data.profiles);
                    return response;
                });
        },

        getProfile(context, id) {
            return this.$axios.get('/profile/' + id)
                .then(response => {
                    if(response.data.profile) {
                        context.commit('setProfile', response.data.profile);
                    }

                    return response;
                });
        },

        clearProfile(context) {
            context.commit('setProfile', null);
        },

        updateProfile(context, data) {
            return this.$axios.put('/profile/' + data.id, data)
                .then(response => {
                    return response;
                });
        },

        updateTmpProfile(context, data) {
            context.commit('setTmpProfile', data.profile);
        },


        deleteProfile(context, id) {
            return this.$axios.delete('/profiles/' + id)
                .then(response => {
                    return response;
                });
        },

        addProfile(context, data) {
            return this.$axios.post('/profiles', data)
                .then(response => {
                    return response;
                });
        },

        setDefaultProfile(context, id) {
            return this.$axios.get('/setDefaultProfile/' + id)
                .then(response => {
                    return response;
                });
        },

        setManualProfileCompletion({commit}, status) {
            commit('setManualProfileCompletion', status);
        },

        resetProfiles({commit}) {
            commit('resetProfiles');
        },

        resetTmpProfile({commit}) {
            commit('resetTmpProfile');
        }
    },
    getters: {
        getProfiles: (state) => {
            return state.profiles;
        },

        getProfile: (state) => {
            return state.profile;
        },

        getTmpProfile: (state) => {
            return state.tmpProfile;
        },

        getManualProfileCompletion: ({ manualProfileCompletion }) => {
            return manualProfileCompletion;
        }
    }
}
